import PropTypes from 'prop-types';
import React from 'react';
import { ControlLabel } from 'react-bootstrap';
import './RequirableControlLabel.css';

// eslint-disable-next-line object-curly-newline
const RequirableControlLabel = ({ children, required, ...props }) => (
  <ControlLabel {...props}>
    {children}
    { required && <span className="required-label" >*</span>}
  </ControlLabel>
);

RequirableControlLabel.defaultProps = {
  required: false,
};

RequirableControlLabel.propTypes = {
  children: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default RequirableControlLabel;



// WEBPACK FOOTER //
// ./src/components/Forms/RequirableControlLabel/RequirableControlLabel.jsx